export const OtpModalActionType = {
    OPEN_OTP_MODAL: 'OPEN_OTP_MODAL',
    OTP_FORM_VALIDATED: 'OTP_FORM_VALIDATED',
    ENTERED_OTP: 'ENTERED_OTP',
    VALIDATE_OTP_BUTTON: 'VALIDATE_OTP_BUTTON',
    VALIDATING_OTP: 'VALIDATING_OTP',
    INCORRECT_OTP: 'INCORRECT_OTP',
    INCORRECT_OTP_LIMIT: 'INCORRECT_OTP_LIMIT',
    INCORRECT_RESPONSE: 'INCORRECT_RESPONSE',
    ENABLE_OTP_SECTION: "ENABLE_OTP_SECTION"
}